import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  RegisterAccountModel,
  RegisterResponse,
  RegisterUserModel,
} from '@seahorse/auth';
import { NotificationService, ResultStatus } from '@seahorse/common';
import { SeahorseAccountService } from '../../services/user-account.service';

@Component({
  selector: 'ca-register-account',
  templateUrl: './register-account.component.html',
  standalone: false,
})
export class RegisterAccountComponent implements OnInit {
  isLoading = false;
  isSubmitted = false;
  registerModel: RegisterAccountModel;
  registerResponse: RegisterResponse;
  user: RegisterUserModel;
  termsAccept: boolean;
  passwordConfirmation: string;
  organisationId: string;

  aadUser = null;
  aadIdentifier = null;
  aadIssuer = null;

  constructor(
    private accountService: SeahorseAccountService,
    public router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    this.registerModel = new RegisterAccountModel();
    this.user = new RegisterUserModel();
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.organisationId = params.get('organisationId');
      this.user.emailAddress = params.get('email');
    });
  }

  registerAccount() {
    if (!this.termsAccept) {
      return;
    }

    this.isLoading = true;

    this.registerModel.users = [];
    this.registerModel.users.push(this.user);

    const languageCode = this.translateService.getDefaultLang();
    this.registerAccountLocal(languageCode);
  }

  registerAccountLocal(languageCode?: string) {
    this.user.username = this.user.emailAddress;

    this.accountService
      .registerAccount(this.registerModel, languageCode)
      .subscribe(
        (response) => {
          if (response.hasResult && response.status === ResultStatus.OK) {
            this.notificationService.showSuccess(
              this.translateService.instant('shared.terms.success')
            );

            this.router.navigateByUrl('/account/register/thank-you');
          } else {
            this.registerResponse = this.accountService.getRegistrationErrors(
              response.messages
            );

            this.isLoading = false;
            this.isSubmitted = false;
          }
        },
        (error) => {
          this.registerResponse =
            this.accountService.getRegistrationErrors(error);

          this.isLoading = false;
          this.isSubmitted = false;
        }
      );
  }

  generatePassword() {
    return (
      Math.random().toString(36).slice(2) +
      Math.random().toString(36).toUpperCase().slice(2)
    );
  }
}
